// src/components/AuthActivity/Loader/Loader.js

import React from "react";
import { Loader2 } from "lucide-react";
import "./Loader.css";

const Loader = ({ text = "Loading..." }) => (
  <div className="loader-container">
    <Loader2 size={32} className="loader-spinner-icon" />
    <p className="loader-text">{text}</p>
  </div>
);

export default Loader;